import { trackPageViewV2 } from "@/services/analytics-adapter";
import theme from "@/theme";
import { convertPxToRem } from "@/utils";
import { Button, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import FullscreenBackground from "@/features/Common/components/FullscreenBackground";
import IconLoader from "@/features/Common/components/IconLoader";

interface PaymentFailureProps {
  onContinue?: () => void;
}

export default function PaymentFailure({ onContinue }: PaymentFailureProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function onBackHomeButtonClick() {
    if (onContinue) {
      return onContinue();
    }

    return navigate("/home");
  }

  useEffect(() => {
    trackPageViewV2({
      pageName: "Medical assistance:Payment failure",
      pageSubSection1: "Medical assistance",
      pageSubSection2: "Medical assistance:Payment failure",
      pageCategory: "Medical assistance",
    });
  }, []);

  return (
    <Stack
      justifyContent="flex-end"
      color="primary.contrastText"
      sx={{
        height: "100%",
      }}
      p={2}
    >
      <IconLoader
        icon="TrolleyWithFilledCrossIcon"
        color={theme.palette.neutral[50] as any}
        sx={{
          fontSize: convertPxToRem(150),
          alignSelf: "center",
        }}
      />

      <Stack textAlign="center" spacing={4} py={4}>
        <Stack spacing={2}>
          <Typography variant="h1" color="inherit">
            {t("PaymentFailure.title")}
          </Typography>
          <Typography variant="h2" color="inherit">
            {t("PaymentFailure.subTitle")}
          </Typography>
        </Stack>
        <Stack spacing={2}>
          {(
            t<any, any, string[]>(`PaymentFailure.body`, {
              returnObjects: true,
            }) as []
          ).map((text: string, index: number) => (
            <Typography
              variant="body1"
              color="inherit"
              key={String(text) + String(index)}
            >
              {text}
            </Typography>
          ))}
        </Stack>
      </Stack>

      <Button onClick={onBackHomeButtonClick} color="info" fullWidth>
        {t("PaymentFailure.backHome")}
      </Button>

      <FullscreenBackground color="primary.main" />
    </Stack>
  );
}
